import { useQuery } from "react-query";

import { getSiteImages } from "../apis/siteImagesApi";
import { SITE_IMAGES_QUERY_KEY } from "../queries-keys/siteImages";

// On error the pages show their bundled images, so no snackbar
const useGetSiteImages = () => {
  const { data: siteImages = {}, isLoading: isLoadingSiteImages } = useQuery(
    SITE_IMAGES_QUERY_KEY(),
    getSiteImages,
    {
      refetchOnMount: false,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
  return { siteImages, isLoadingSiteImages };
};

export default useGetSiteImages;
